import { push } from "connected-react-router";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { roles } from "../actions";

const PoliciesTableRoleLink = ({ roleUri, label, push, setCurrentRole }) => {
  const openRoles = uri => {
    setCurrentRole(uri);
    push("/policies/roles");
  };

  return (
    <div className="p-table__cell">
      <button
        type="button"
        className="p-button--link p-muted-heading"
        onClick={() => openRoles(roleUri)}
      >
        <span>{label}</span>
      </button>
    </div>
  );
};

PoliciesTableRoleLink.propTypes = {
  roleUri: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  push: PropTypes.func.isRequired,
  setCurrentRole: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  push,
  setCurrentRole: roles.setCurrent
};

export default connect(
  null,
  mapDispatchToProps
)(PoliciesTableRoleLink);
